import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle2 } from 'lucide-react';
export function Contact() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => {
      setStatus('success');
      setTimeout(() => setStatus('idle'), 5000);
    }, 1500);
  };
  return <section id="contact" className="py-24 relative z-10" data-id="element-1">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2">
        <div className="rounded-3xl bg-gradient-to-br from-[#0a0b14] to-[#131528] border border-white/10 p-8 md:p-12 shadow-[0_0_50px_rgba(6,182,212,0.1)] relative overflow-hidden" data-id="element-3">
          {/* Background glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-4" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-violet-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-5" />

          <div className="relative z-10 text-center mb-10" data-id="element-6">
            <h2 className="text-4xl font-bold text-white mb-4" data-id="element-7">צרו קשר</h2>
            <p className="text-gray-400" data-id="element-8">
              השאירו פרטים ונחזור אליכם מעבר לכוכבים.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-2 text-sm text-gray-400" data-id="element-9">
              <span data-id="element-10">
                <span className="text-cyan-400" data-id="element-11">דוא״ל:</span> mission@nebula.space
              </span>
              <span data-id="element-12">
                <span className="text-cyan-400" data-id="element-13">מטה:</span> תל אביב, ישראל
              </span>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="relative z-10 flex flex-col gap-6 max-w-2xl mx-auto" data-id="element-14">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-15">
              <input type="text" required placeholder="שם מלא" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 transition-all" data-id="element-16" />
              <input type="email" required placeholder="דואר אלקטרוני" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 transition-all" data-id="element-17" />
            </div>
            <textarea required placeholder="איך נוכל לעזור?" rows={4} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 transition-all resize-none" data-id="element-18" />

            <button type="submit" disabled={status !== 'idle'} className="w-full md:w-auto md:self-center px-10 py-4 rounded-full bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold text-lg hover:shadow-[0_0_20px_rgba(6,182,212,0.4)] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-19">
              {status === 'idle' && <>
                  <Send className="w-5 h-5 ml-2" data-id="element-20" /> שלח הודעה
                </>}
              {status === 'submitting' && <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-21" />}
              {status === 'success' && <>
                  <CheckCircle2 className="w-5 h-5 ml-2" data-id="element-22" /> נשלח בהצלחה
                </>}
            </button>
          </form>

          {/* Success Toast */}
          {status === 'success' && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-emerald-500/20 border border-emerald-500/50 text-emerald-200 px-6 py-3 rounded-full backdrop-blur-md flex items-center gap-2" data-id="element-23">
              <CheckCircle2 className="w-5 h-5" data-id="element-24" />
              תודה! ניצור קשר מעבר לכוכבים.
            </motion.div>}
        </div>
      </div>
    </section>;
}